import { ButtonProps } from '@usacsmideo/types';

export const Button = (props: ButtonProps) => {
  if (props.submitted === true) {
    return (
      <button
        id={props.id}
        className={
          props.classNameOverride
            ? props.classNameOverride
            : 'my-4 rounded-md bg-[#730D0E]/50 px-4 py-2 text-xl text-white hover:bg-[#730D0E]/70 disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-500 disabled:shadow-none sm:px-8 sm:py-3'
        }
        type={props.type || 'button'}
        onClick={props.onClick}
        disabled={props.disabled}
      >
        {props.working && props.working === true ? (
          <span className="ml-2">{props.workingText}</span>
        ) : (
          props.textContent
        )}
      </button>
    );
  } else {
    return (
      <button
        id={props.id}
        className={
          props.classNameOverride
            ? props.classNameOverride
            : 'my-4 rounded-md bg-[#730D0E] px-4 py-2 text-xl text-white hover:bg-[#730D0E]/90 disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-500 disabled:shadow-none sm:px-8 sm:py-3'
        }
        type={props.type || 'button'}
        onClick={props.onClick}
        disabled={props.disabled}
      >
        {props.working && props.working === true ? (
          <span className="ml-2">{props.workingText}</span>
        ) : (
          props.textContent
        )}
      </button>
    );
  }
};

Button.displayName = 'Button';
